// Active deals opened from an LO record's "Business with LendSure": what is shown, a way back to the
// LO, and Clear. "New loan" is hidden in this view (lib/loBusiness.ts `pipelineView`), so the bar
// says how to add one.
import { Link } from "react-router";
import { NO_STAGE } from "../lib/loBusiness";
import { hasProspecting } from "../lib/roles";
import type { Me } from "../lib/types";
import { Button } from "./ui";

export function LoFilterBar({
  me,
  lo,
  stage,
  openOnly,
  createHint,
  onClear,
}: {
  me: Me;
  lo: string;
  stage: string | null;
  openOnly: boolean;
  createHint: string | null;
  onClear: () => void;
}) {
  const stageLabel = stage === NO_STAGE ? "Stage not set" : stage ? (me.stages.find((s) => s.key === stage)?.label ?? null) : null;
  const what = [stageLabel, openOnly ? "Active (not funded)" : null].filter(Boolean).join(" · ");
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 rounded-md border border-subtle bg-sunken px-3 text-[13px] text-ink-2" role="status">
      <span className="py-2">
        Every loan you can see that is linked to this LO, colleagues' included
        {what ? (
          <>
            {" "}
            · <span className="font-semibold text-ink">{what}</span>
          </>
        ) : null}
        {createHint ? <span className="block text-[12px] text-ink-3">{createHint}.</span> : null}
      </span>
      <span className="ml-auto flex items-center gap-1">
        {hasProspecting(me) ? (
          <Link to={`/prospecting/people/${lo}`} className="focus-ring inline-flex min-h-11 items-center rounded-md px-2 text-link hover:underline">
            Back to the LO
          </Link>
        ) : null}
        <Button variant="ghost" className="min-h-11" onClick={onClear}>
          Clear
        </Button>
      </span>
    </div>
  );
}
